import { createFileRoute } from "@tanstack/react-router";
import { OutboundVerificationContractsPage } from "@/features/outbound/outbound-verification-contracts-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/weryfikacja-wysylek/")({
	component: OutboundVerificationContractsPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.weryfikacja-wysylek",
			location.pathname,
		);
	},
});
